const svgToPngDataUrl = async (svgUrl: string, size = 512): Promise<string | null> => {
  try {
    const res = await fetch(svgUrl, { credentials: 'same-origin' });
    if (!res.ok) {
      return null;
    }

    const svgText = await res.text();
    const svgBlob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
    const blobUrl = URL.createObjectURL(svgBlob);

    try {
      const img = await new Promise<HTMLImageElement>((resolve, reject) => {
        const i = new Image();
        i.onload = () => resolve(i);
        i.onerror = reject;
        i.src = blobUrl;
      });

      const width = img.naturalWidth || size;
      const height = img.naturalHeight || size;

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        return null;
      }

      ctx.drawImage(img, 0, 0, width, height);
      return canvas.toDataURL('image/png');
    } finally {
      URL.revokeObjectURL(blobUrl);
    }
  } catch {
    return null;
  }
};

export const replaceSvgImgsWithPng = async (container: HTMLElement) => {
  const imgs = Array.from(container.querySelectorAll('img'));
  const svgImgs = imgs.filter((img) => {
    try {
      const u = new URL(img.src, window.location.href);
      return u.pathname.toLowerCase().endsWith('.svg');
    } catch {
      return false;
    }
  });

  await Promise.all(
    svgImgs.map(async (img) => {
      const pngDataUrl = await svgToPngDataUrl(img.src);
      if (!pngDataUrl) {
        return;
      }

      await new Promise<void>((resolve) => {
        const done = () => resolve();
        img.onload = done;
        img.onerror = done;
        img.src = pngDataUrl;
      });
    })
  );
};
